import clsx from "clsx";
import { ForwardedRef } from "react";
import { twMerge } from "tailwind-merge";
import { PropsWithAs } from "../types";
import { forwardRefWithGeneric } from "../utils";
import { useModal } from "./modalContext";

export interface ModalBodyProps {}

const ModalBody = <T extends React.ElementType = "div">(
  { as, ...props }: PropsWithAs<ModalBodyProps, T>,
  ref: ForwardedRef<any>
) => {
  const { className, ...rest } = props;
  const { scrollable } = useModal();
  const Component = as ?? "div";

  return (
    <Component
      {...rest}
      ref={ref}
      className={twMerge(
        "px-4 last:pb-4 first:pt-4",
        clsx("max-h-full relative", {
          "overflow-y-auto": scrollable,
        }),
        className
      )}
    />
  );
};

export default forwardRefWithGeneric(ModalBody);
